import React from "react";
import { getRecoil, setRecoil } from "recoil-nexus";
import io, { Socket } from "socket.io-client";
import ApiController from "../../controller/ApiController";
import {
  CALL_TYPE_RECEIVER,
  INTERPHONE_STATUS_CALLING,
  INTERPHONE_STATUS_CANCEL,
  INTERPHONE_STATUS_RECEIVER_WAIT,
} from "../../controller/InterphoneController";
import MessageController from "../../controller/MessageController";
import { useToast } from "../../controller/ToastController";
import { authState } from "../../recoil/auth";
import {
  csChatFinishedState,
  csChatListState,
  csChatState,
  newChatListState,
  storeChatFinishedState,
  storeChatState,
} from "../../recoil/chat";
import { interphoneState } from "../../recoil/interphone";
import { langState, langText } from "../../recoil/lang";
import {
  checkoutState,
  conciergeState,
  connectState,
  refreshOrderState,
  requestReviewState,
} from "../../recoil/socket";
import { ORDER_CANCLE_STATUS, ORDER_COM_DEL_STATUS } from "../../recoil/type";
import taskQueue from "../../utils/TaskQueue";

const SocketService = React.memo((oProps: any) => {
  // const auth = useRecoilValue(authState);
  const showToast = useToast();

  const processMsg = async (
    oParsed: {
      user_token_id: number;
      action: string;
      url: string;
      params: any;
      send_log_id: number;
    },
    socket: Socket
  ) => {
    window.ReactNativeWebView?.postMessage(
      MessageController.getEchoData(JSON.stringify(oParsed))
    );

    try {
      console.log("enqueue", JSON.stringify(oParsed));
      // if (oParsed && oParsed.action && oParsed.action === "refresh") {
      //   window.ReactNativeWebView?.postMessage(
      //     MessageController.getActionData("refresh")
      //   );
      // } else if (oParsed && oParsed.action && oParsed.action === "capture") {
      //   window.ReactNativeWebView?.postMessage(
      //     MessageController.getActionData("capture")
      //   );
      // } else if (oParsed && oParsed.action && oParsed.action === "restart") {
      //   window.ReactNativeWebView?.postMessage(
      //     MessageController.getActionData("restart")
      //   );
      // }
      if (oParsed && oParsed.action && oParsed.action === "newOrder") {
        setRecoil(refreshOrderState, {
          date: new Date().getTime(),
          order_category: oParsed.params.order_category,
          order_status: 0,
        });
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "changeOrder"
      ) {
        if (oParsed.params.order_status === ORDER_CANCLE_STATUS) {
          setRecoil(refreshOrderState, {
            date: new Date().getTime(),
            order_category: oParsed.params.order_category,
            order_status: oParsed.params.order_status,
            cancel_description: oParsed.params.cancel_description,
          });
        } else if (oParsed.params.order_status === ORDER_COM_DEL_STATUS) {
          setRecoil(refreshOrderState, {
            date: new Date().getTime(),
            order_category: oParsed.params.order_category,
            order_status: oParsed.params.order_status,
            pickup_name: oParsed.params.pickup_name,
            pickup_name_en: oParsed.params.pickup_name_en,
          });
        } else {
          setRecoil(refreshOrderState, {
            date: new Date().getTime(),
            order_category: oParsed.params.order_category,
            order_status: oParsed.params.order_status,
          });
        }
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "requestReview"
      ) {
        setRecoil(requestReviewState, {
          order_id: oParsed.params.order_id,
          order_seq: oParsed.params.order_seq,
          status: oParsed.params.status,
          user_token_id: oParsed.params.user_token_id,
          store_id: oParsed.params.store_id,
          parent_store_id: oParsed.params.parent_store_id,
          store_name: oParsed.params.store_name,
          product_name: oParsed.params.product_name,
          product_name_en: oParsed.params.product_name_en,
          product_name_ch: oParsed.params.product_name_ch,
          product_name_ja: oParsed.params.product_name_ja,
          product_name_th: oParsed.params.product_name_th,
          product_quantity: oParsed.params.product_quantity,
        });
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "notification"
      ) {
        console.log("oParams", oParsed);
        setRecoil(checkoutState, (prev) => ({
          ...prev,
          date: new Date().getTime().toString(),
          notice_detail_id: oParsed.params.notice_detail_id,
          log_id: oParsed.params.log_id,
          can_purchase_more_time: oParsed.params.can_purchase_more_time,
        }));
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "CONCIERGE_MESSAGE"
      ) {
        setRecoil(conciergeState, {
          concierge_id: oParsed.params.concierge_id,
          isChat: false,
          date: new Date().getTime().toString(),
        });
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "DIRECT_MESSAGE"
      ) {
        if (oParsed.params.contact_person_type === "STORE") {
          setRecoil(storeChatState, (prev) => ({
            ...prev,
            cs_id: oParsed.params.cs_id,
            date: new Date().getTime().toString(),
          }));
          if (oParsed.params.status && oParsed.params.status === "FINISHED") {
            setRecoil(storeChatFinishedState, true);
          } else {
            if (
              getRecoil(newChatListState).findIndex(
                (item) =>
                  item.order_id === oParsed.params.order_id &&
                  item.order_seq === oParsed.params.order_seq &&
                  item.store_id === oParsed.params.store_id
              ) === -1
            ) {
              setRecoil(newChatListState, (prev) => [
                ...prev,
                {
                  cs_id: oParsed.params.cs_id,
                  store_id: oParsed.params.store_id,
                  order_id: oParsed.params.order_id,
                  order_seq: oParsed.params.order_seq,
                },
              ]);
            }
          }
        } else if (oParsed.params.contact_person_type === "ADMIN") {
          setRecoil(csChatState, (prev) => ({
            ...prev,
            cs_id: oParsed.params.cs_id,
            date: new Date().getTime().toString(),
          }));
          setRecoil(csChatListState, true);
          if (oParsed.params.status && oParsed.params.status === "FINISHED") {
            setRecoil(csChatFinishedState, true);
          }
        }
      } else if (oParsed && oParsed.action && oParsed.action === "INTERPHONE") {
        console.log("oParams", oParsed);
        // 상대방의 통화 수락
        if (oParsed.params.type === "RECEIVER_ACCEPT") {
          setRecoil(interphoneState, (prev) => ({
            ...prev,
            interphone_call_manage_id: oParsed.params.interphone_call_manage_id,
            status: INTERPHONE_STATUS_CALLING,
          }));
        }
        // 통화 수신
        else if (oParsed.params.type === "REQUEST_INCOME") {
          setRecoil(interphoneState, (prev) => ({
            ...prev,
            type: CALL_TYPE_RECEIVER,
            interphone_call_manage_id: oParsed.params.interphone_call_manage_id,
            status: INTERPHONE_STATUS_RECEIVER_WAIT,
          }));
          await ApiController.interphone.setReqCallDataReceived({
            manage_id: oParsed.params.interphone_call_manage_id,
          });
        }
        // 방 생성
        else if (oParsed.params.type === "CREATED_ROOM") {
          setRecoil(interphoneState, (prev) => ({
            ...prev,
            interphone_call_manage_id: oParsed.params.interphone_call_manage_id,
            // room_name: oParsed.params.room_name,
            // status: INTERPHONE_STATUS_CALLING,
          }));
        }
        // 상대방의 통화 거절
        else if (oParsed.params.type === "REQUEST_CANCEL_BY_RECEIVER") {
          setRecoil(interphoneState, (prev) => ({
            ...prev,
            interphone_call_manage_id: oParsed.params.interphone_call_manage_id,
            room_name: null,
            status: INTERPHONE_STATUS_CANCEL,
            reject_reason:
              langText.interphone_reject_receiver[getRecoil(langState)],
          }));
        }
        // 발신자의 통화 거절
        else if (oParsed.params.type === "REQUEST_CANCEL_BY_SENDER") {
          setRecoil(interphoneState, (prev) => ({
            ...prev,
            interphone_call_manage_id: oParsed.params.interphone_call_manage_id,
            room_name: null,
            status: INTERPHONE_STATUS_CANCEL,
            reject_reason:
              langText.interphone_reject_sender[getRecoil(langState)],
          }));
        }
        // 60초 후 자동 취소
        else if (oParsed.params.type === "REQUEST_CANCEL_BY_TIMEOUT") {
          setRecoil(interphoneState, (prev) => ({
            ...prev,
            interphone_call_manage_id: oParsed.params.interphone_call_manage_id,
            room_name: null,
            status: INTERPHONE_STATUS_CANCEL,
            reject_reason:
              langText.interphone_reject_not_connect[getRecoil(langState)],
          }));
        }
      } else if (oParsed && oParsed.action) {
        window.ReactNativeWebView?.postMessage(
          MessageController.getActionData(oParsed.action, oParsed.params)
        );
      }
    } catch (err) {
      console.log("!!!!!processMsg error:", err);
    } finally {
      socket.emit("confirm", "OK");
    }
  };

  // const [sReceivedMsg, set_sReceivedMsg] = React.useState<any>('');

  const startSocket = async () => {
    console.log("start!!!!");
    // let token = await AppConfigController.getObjectCryptoAsyncStorage('refresh-token');
    // let token = nowAuth.refreshToken;
    // let token = await RecoilAsyncStorage.getItem('refresh-token');

    let socket = io(`${process.env.REACT_APP_WEBSOCKET_URL}`, {
      transports: ["websocket", "polling"],
      autoConnect: false,
      auth: { token: getRecoil(authState).refresh_token },
      reconnection: true,
      reconnectionDelay: 500,
    });

    //auth: { token: token },

    // console.log('Config.WEBSOCKET_URL', Config.WEBSOCKET_URL);

    window.ReactNativeWebView?.postMessage(
      MessageController.getEchoData(
        JSON.stringify({
          go: "=====>>>",
          socket: process.env.REACT_APP_WEBSOCKET_URL,
          token: getRecoil(authState).refresh_token,
        })
      )
    );

    socket.connect();
    socket.on("connect", () => {
      console.log("connected --------------- socket ---------------");
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData(JSON.stringify({ go: "=====>>>connect" }))
      );
      setRecoil(connectState, { type: true, is_first: false });
    });

    socket.on("connect_error", (err: any) => {
      console.log(err.message);
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData(
          JSON.stringify({ go: "=====>>>error-con", err: err.toString() })
        )
      );
      window.ReactNativeWebView?.postMessage(
        MessageController.getActionData("refresh", {})
      );
      setRecoil(connectState, { type: false, is_first: false });
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from server");
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData(
          JSON.stringify({ go: "=====>>>disconnect" })
        )
      );
      window.ReactNativeWebView?.postMessage(
        MessageController.getActionData("refresh", {})
      );
      setRecoil(connectState, { type: false, is_first: false });
    });

    socket.on("msg", async (msg: any) => {
      // window.ReactNativeWebView?.postMessage(
      //   MessageController.getEchoData({ msg: JSON.stringify(msg) })
      // );

      if (msg) {
        try {
          let oParsed = JSON.parse(msg);
          taskQueue.enqueueTask(() => processMsg(oParsed, socket));
        } catch (err) {
          console.log(err);
          console.log(msg);
        }
      }
    });
  };

  React.useEffect(() => {
    console.log(`socket url: ${process.env.REACT_APP_WEBSOCKET_URL}`);

    setTimeout(() => {
      startSocket();
    }, 5000);
  }, []);

  return <></>;
});

export default SocketService;
